import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';
import { locale } from './locale';
import styles from './DeleteAddonModal.css';

export const DeleteAddonModal = injectIntl(({ intl, isOpen, onCloseClicked, onDeleteClicked, areYouSureContent }) => {

  return (
    <Modal className={styles.container}
      centered
      open={isOpen}
      closeIcon
      onClose={() => onCloseClicked()}
      size="tiny">
      <Modal.Header>{intl.formatMessage(locale.title)}</Modal.Header>
        <Modal.Content>
            <React.Fragment>
              <React.Fragment>
                <div className={`${styles.copy}`}>{areYouSureContent}</div>
                <div className={`${styles.copy} ${styles.deletionIsFinal}`}>
                  {intl.formatMessage(locale.cannotBeUndone)}
                </div>
              </React.Fragment>
              <Button negative
                className={styles.deleteButton}
                onClick={() => onDeleteClicked()}
              >
                {intl.formatMessage(locale.delete)}
              </Button>
            </React.Fragment>
            <Button default
              className={styles.cancelButton}
              onClick={() => onCloseClicked()}
            >
              {intl.formatMessage(locale.cancel)}
            </Button>
        </Modal.Content>
    </Modal>
  );
});

export default DeleteAddonModal;
